import CanteenNewLogo from 'src/components/img/svg/CanteenNewLogo';
import PayNewLogo from 'src/components/img/svg/365PayNewLogo';
import PayRocketIcon from 'src/components/img/svg/365RocketIcon';
import CanteenRocketIcon from 'src/components/img/svg/CanteenRocketIcon';
import Settings from 'src/Settings';
import Styles from 'src/components/Styles';
import WelcomeRefiveLogo from 'src/components/img/svg/WelcomeRefiveLogo';
import CKLogoReferal from 'src/components/img/svg/CKLogoReferal';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
import AramarkLogo from 'src/components/img/svg/AramarkLogo';

const referralThemeConfigurations = {
  [BuildTypeEnum.aramark]: {
    icon: <AramarkLogo size={197} />,
    colors: [Styles.Colors.Aramark.blue],
    locations: [0.1, 0.25, 0.5, 1.0],
    start: {x: 0, y: 0},
    end: {x: 0, y: 1},
    buttonColor: Styles.Colors.Aramark.primary,
    amountColor: Styles.Colors.Aramark.primary,
    starIconColor: Styles.Colors.Canteen.green,
    textFontFamily: Styles.FontFamily.gothamRegular,
    amountFontFamily: Styles.FontFamily.gothamRegular,
    textFontFamilyColor: Styles.Colors.PayNew.black01,
    accountReadyIcon: <CanteenRocketIcon />,
  },
  [BuildTypeEnum.canteen]: {
    icon: <CanteenNewLogo />,
    colors: [
      Styles.white,
      'rgba(251, 255, 243, 1)',
      'rgba(227, 244, 192, 1)',
      Styles.Colors.Canteen.lightGreen,
    ],
    locations: [0.1, 0.25, 0.5, 1.0],
    start: {x: 0, y: 0},
    end: {x: 0, y: 1},
    buttonColor: Styles.Colors.Canteen.primary,
    amountColor: Styles.Colors.Canteen.primary,
    starIconColor: Styles.Colors.Canteen.green,
    textFontFamily: Styles.FontFamily.robotoRegular,
    amountFontFamily: Styles.FontFamily.robotoRegular,
    textFontFamilyColor: Styles.Colors.PayNew.black01,
    accountReadyIcon: <CanteenRocketIcon />,
  },
  [BuildTypeEnum.default]: {
    icon: <PayNewLogo />,
    colors: [
      Styles.Colors.PayNew.support01,
      Styles.Colors.PayNew.blueHuesBase07,
    ],
    start: {x: 0, y: 0},
    end: {x: 0, y: 1},
    locations: [0, 0.4537],
    buttonColor: Styles.Colors.PayNew.primary01,
    amountColor: Styles.Colors.PayNew.primary01,
    starIconColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    amountFontFamily: Styles.FontFamily.aeonikRegular,
    textFontFamilyColor: Styles.Colors.PayNew.black01,
    accountReadyIcon: <PayRocketIcon />,
  },
  [BuildTypeEnum.companykitchen]: {
    icon: <CKLogoReferal />,
    colors: [Styles.white, Styles.white],
    locations: [0.1, 0.25, 0.5, 1.0],
    start: {x: 0, y: 0},
    end: {x: 0, y: 1},
    buttonColor: Styles.Colors.CompanyKitchen.green,
    amountColor: Styles.Colors.Canteen.primary,
    starIconColor: Styles.Colors.Canteen.green,
    textFontFamily: Styles.FontFamily.latoRegular,
    amountFontFamily: Styles.FontFamily.latoRegular,
    textFontFamilyColor: Styles.Colors.PayNew.black01,
    accountReadyIcon: <CanteenRocketIcon />,
  },
  [BuildTypeEnum.refive]: {
    icon: <WelcomeRefiveLogo />,
    colors: ['rgba(69, 136, 253, 0.15)', 'rgba(69, 136, 253, 0.15)'],
    start: {x: 0, y: 0},
    end: {x: 0, y: 1},
    locations: [0, 0.4537],
    buttonColor: Styles.Colors.Refive.activeFooterBlue,
    amountColor: Styles.Colors.Refive.activeFooterBlue,
    starIconColor: Styles.Colors.Refive.activeFooterBlue,
    textFontFamily: Styles.FontFamily.figtreeRegular,
    amountFontFamily: Styles.FontFamily.figtreeRegular,
    textFontFamilyColor: Styles.Colors.Refive.navy,
    accountReadyIcon: <PayRocketIcon />,
  },
};
export const referralTemplate = referralThemeConfigurations[Settings.buildType];
